window.onLoad = function onLoad(f) {
  const run = () => {
    if (typeof $ === 'undefined') return;
    f($);
  };

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('turbolinks:load', run);
  document.addEventListener('turbo:load', run);
};

// Evita selects duplicados ao voltar (Turbolinks restaura HTML com Select2 já montado).
window.destroySelect2 = function destroySelect2($elements) {
  $elements.each(function () {
    const $el = $(this);
    if ($el.hasClass('select2-hidden-accessible')) {
      $el.select2('destroy');
    }
  });
};

document.addEventListener('turbolinks:before-cache', () => {
  if (typeof $ === 'undefined' || !$.fn.select2) return;
  destroySelect2($('.select2-hidden-accessible'));
});

window.turbolinksSetInterval = function turbolinksSetInterval(intervalFunction, milliseconds) {
  const interval = setInterval(intervalFunction, milliseconds);

  function removeInterval() {
    clearInterval(interval);
    $(document).off('turbolinks:load', removeInterval);
  }

  $(document).on('turbolinks:load', removeInterval);
};

String.prototype.replaceAll = function(from, to){
  var str = this;
  var pos = str.indexOf(from);
  while (pos > -1){
    str = str.replace(from, to);
    pos = str.indexOf(from);
  }
  return (str);
}
